import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Label } from './ui/label';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { formatLength } from '../utils/units';
import emailjs from 'emailjs-com';

export default function BudgetContact({ configuration, pricing, units = 'imperial', mailTo = '', onUnlock }) {
  const [form, setForm] = useState({ name: '', email: '', phone: '' });
  const [sending, setSending] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const buildTemplateParams = () => {
    const len = formatLength(configuration.length, units);
    const wid = formatLength(configuration.width, units);
    const total = pricing?.total ? `$${Math.round(pricing.total).toLocaleString()}` : '—';
    return {
      // contact
      name: form.name,
      email: form.email,
      phone: form.phone,
      // config
      truss_type: configuration.trussType,
      material: configuration.material,
      railing: configuration.railing,
      decking: configuration.decking,
      length_label: len,
      width_label: wid,
      camber_in: configuration.camber,
      load_rating: configuration?.subModifiers?.loadRating || '10k',
      // estimate
      estimated_total: total,
      to_email: mailTo || 'info@coyotebridges.com',
    };
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.email) {
      window.alert('Please enter your email');
      return;
    }
    setSending(true);
    try {
      const params = buildTemplateParams();
      const res = await emailjs.send(
        'service_m7m4b68',
        'template_mmd7hds',
        params,
        'bgVBQRZeAw9plltXd'
      );
      if (res && (res.status === 200 || res.text === 'OK')) {
        if (typeof onUnlock === 'function') onUnlock({ ...form });
      } else {
        window.alert('We could not send your request right now. Please try again.');
      }
    } catch (err) {
      console.error('EmailJS send failed', err);
      window.alert('We could not send your request right now. Please try again.');
    } finally {
      setSending(false);
    }
  };

  return (
    <Card className="glass-card shadow-xl">
      <CardHeader className="pb-3">
        <CardTitle className="text-slate-100 text-lg">Request Budget Price</CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={onSubmit} className="grid grid-cols-1 gap-3">
          <div>
            <Label htmlFor="bc-name" className="text-slate-300 text-sm">Your Name</Label>
            <Input id="bc-name" name="name" value={form.name} onChange={handleChange} className="bg-slate-700 border-slate-600 text-slate-200" placeholder="Jane Doe" />
          </div>
          <div>
            <Label htmlFor="bc-email" className="text-slate-300 text-sm">Email</Label>
            <Input id="bc-email" type="email" name="email" value={form.email} onChange={handleChange} className="bg-slate-700 border-slate-600 text-slate-200" placeholder="you@company.com" required />
          </div>
          <div>
            <Label htmlFor="bc-phone" className="text-slate-300 text-sm">Phone</Label>
            <Input id="bc-phone" name="phone" value={form.phone} onChange={handleChange} className="bg-slate-700 border-slate-600 text-slate-200" placeholder="(555) 123-4567" />
          </div>
          <Button type="submit" disabled={sending} className="w-full bg-emerald-600 hover:bg-emerald-700 text-white">
            {sending ? 'Opening email…' : 'Request Budget Price'}
          </Button>
          <p className="text-[11px] text-slate-500">Submits via your email client with current configuration and estimated total.</p>
        </form>
      </CardContent>
    </Card>
  );
}
